import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Company
 * @summary Confirm company INN and legal name
 */
export const ConfirmCompanyInnContentType = '' as const;
export type ConfirmCompanyInnRequest = void;
export type ConfirmCompanyInnResponses = LinkCommonErrorResponses & {};
export type ConfirmCompanyInnResponseSuccess = undefined;
export type ConfirmCompanyInnSearchParams = undefined;
export type ConfirmCompanyInnPathParameters = undefined;
export const ConfirmCompanyInnUrl = '/company/inn/confirm' as const;
export const ConfirmCompanyInnMethod = 'POST' as const;
export const getConfirmCompanyInnUrl = (_params?: ConfirmCompanyInnPathParameters) => ConfirmCompanyInnUrl;
